import z from "zod";
import { PreSalesProjectIndexSchema } from "rdx/modules/projects/schemas/projects/pre-sales";
import { PostSalesProjectIndexSchema } from "rdx/modules/projects/schemas/projects/post-sales";

export const ParsedQueryParamSchema = z.union([z.string(), z.string().nullable().array(), z.undefined()]).nullable();

export const BaseOrgProjectsFilterSchema = z.object({
  q: ParsedQueryParamSchema,
  from: ParsedQueryParamSchema,
  to: ParsedQueryParamSchema,
  mentored: ParsedQueryParamSchema,
  consultant_id: ParsedQueryParamSchema,
  mentor_id: ParsedQueryParamSchema,
  sort: ParsedQueryParamSchema,
  team_view: z.boolean().optional(),
});

export const OrgPreSalesFilterParamsSchema = BaseOrgProjectsFilterSchema.extend({
  status: ParsedQueryParamSchema,
  milestone_names: ParsedQueryParamSchema,
  lead_offer_status: ParsedQueryParamSchema,
  lead_source_role: ParsedQueryParamSchema,
  lead_source_ids: ParsedQueryParamSchema,
  lead_owner_ids: ParsedQueryParamSchema,
  state_name: ParsedQueryParamSchema,
});

export const OrgPostSalesFilterParamsSchema = BaseOrgProjectsFilterSchema.extend({
  status: ParsedQueryParamSchema,
  stage_name: ParsedQueryParamSchema,
  state_name: ParsedQueryParamSchema,
  battery_upsell: ParsedQueryParamSchema,
});

export const OrgCompletedFilterParamsSchema = BaseOrgProjectsFilterSchema.extend({
  battery_upsell: ParsedQueryParamSchema,
});

export const GetOrgPreSalesParamsSchema = z.object({
  filterParams: OrgPreSalesFilterParamsSchema,
});

export const GetOrgPostSalesParamsSchema = z.object({
  filterParams: OrgPreSalesFilterParamsSchema,
});

export const GetOrgCompletedParamsSchema = z.object({
  filterParams: OrgPreSalesFilterParamsSchema,
});

export const GetOrgPreSalesResponseSchema = z.object({
  body: z.object({
    paging: z.object({
      itemCount: z.number(),
      pageNumber: z.number(),
      pageSize: z.number(),
      hasMore: z.boolean(),
      nextCursor: z.string().nullish(),
    }),
    projects: z.array(PreSalesProjectIndexSchema),
  }),
});

export const GetOrgPostSalesResponseSchema = z.object({
  body: z.object({
    paging: z.object({
      itemCount: z.number(),
      totalCount: z.number().nullable(),
      pageNumber: z.number(),
      pageSize: z.number(),
      hasMore: z.boolean(),
    }),
    providerLeads: z.array(PostSalesProjectIndexSchema),
  }),
});

export const GetOrgCompletedResponseSchema = z.object({
  body: z.object({
    paging: z.object({
      itemCount: z.number(),
      totalCount: z.number().nullable(),
      pageNumber: z.number(),
      pageSize: z.number(),
      hasMore: z.boolean(),
    }),
    providerLeads: z.array(PostSalesProjectIndexSchema),
  }),
});

export const GetMoreOrgPreSalesParamsSchema = z.object({
  p: z.number(),
  cursor: z.string().nullish(),
  filterParams: OrgPreSalesFilterParamsSchema,
});

export const GetMoreOrgPostSalesParamsSchema = z.object({
  p: z.number(),
  filterParams: OrgPostSalesFilterParamsSchema,
});

export const GetMoreOrgCompletedParamsSchema = z.object({
  p: z.number(),
  filterParams: OrgCompletedFilterParamsSchema,
});
